var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlTennisCourtFilled = function SvgHtlTennisCourtFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.143 8c.287 0 .574-.024.857-.072A6 6 0 0 0 8.072 2a5.144 5.144 0 0 0 5.071 6Zm-5.214 6A5.398 5.398 0 0 0 8 13.14a5.144 5.144 0 0 0-6-5.067A6 6 0 0 0 7.929 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.908 7.092a6.014 6.014 0 0 1-1.773-4.281c0-.271.018-.542.054-.811A6.057 6.057 0 0 0 2 7.189a6.11 6.11 0 0 1 3.13.404A6.043 6.043 0 0 1 8.81 14 6.057 6.057 0 0 0 14 8.811a6.11 6.11 0 0 1-3.13-.404 6.015 6.015 0 0 1-1.962-1.315Z"
  })));
};
export default SvgHtlTennisCourtFilled;